/**
 * Picks the relevant price value based on the given LuxPlus membership state.
 */
function getItemViewTotalsPrice(
  totals: App.Checkout.ItemViewTotals,
  isMember: boolean,
): number {
  return ((isMember && totals.memberPrice) || totals.price) + totals.surcharge
}

export default getItemViewTotalsPrice
